import React from 'react';
import { Permission } from '@server/permissions';
import { PropsWithChildren } from 'react';
import useCheckAccountPermissions from './permissions/useCheckAccountPermissions';
import { Tooltip } from '@sweep-io/sweep-design';

//This component is adding a tooltip and a "disabled" prop to the children, according to the user's account permissions
const WithAccountPermissions = (
  props: PropsWithChildren<{ permissionStr: Permission[]; disabledTooltip: string }>,
) => {
  const { children, permissionStr, disabledTooltip } = props;
  const permissions = useCheckAccountPermissions(permissionStr);
  const isAllowed = permissions.every((permission) => permission);

  const childrenWithProps = React.isValidElement(children)
    ? React.cloneElement(children, {
        ...children.props,
        disabled: !isAllowed,
      })
    : undefined;

  if (isAllowed) {
    return <>{childrenWithProps}</>;
  }

  return (
    <Tooltip title={disabledTooltip} placement="top">
      <span>{childrenWithProps}</span>
    </Tooltip>
  );
};

export default WithAccountPermissions;
